import React from 'react';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Error from '@material-ui/icons/Error';
import OpenInNew from '@material-ui/icons/OpenInNew';

import axios from '../../../axios';

class VideoRotationCard extends React.Component {
    state = {
        status: 'idle', // idle | loading | success | error
        errorMessage: null
    };

    handleAdd = () => {
        const { video, token, domainID } = this.props;

        this.setState({ status: 'loading', errorMessage: null });

        axios.defaults.headers.common['Authorization'] = token;

        axios.post('https://okancelik.com.tr/api/extension-api/add-video', {
            url: video.sourceUrl,
            domainID: domainID,
            autoTitle: "1"
        })
        .then(() => {
            this.setState({ status: 'success' });
        })
        .catch(err => {
            const message = err.response?.data?.message || 'Bir hata oluştu';
            this.setState({ status: 'error', errorMessage: message });
        });
    };

    renderButton = () => {
        const { status, errorMessage } = this.state;

        switch (status) {
            case 'loading':
                return (
                    <Button
                        variant="contained"
                        color="default"
                        fullWidth
                        disabled
                        className="VideoRotationButton loading"
                    >
                        <CircularProgress size={20} />
                    </Button>
                );
            case 'success':
                return (
                    <Button
                        variant="contained"
                        fullWidth
                        disabled
                        className="VideoRotationButton success"
                    >
                        <CheckCircle style={{ marginRight: 4 }} /> Kuyrukta
                    </Button>
                );
            case 'error':
                return (
                    <React.Fragment>
                        <Button
                            variant="contained"
                            color="secondary"
                            fullWidth
                            onClick={this.handleAdd}
                            className="VideoRotationButton error"
                        >
                            <Error style={{ marginRight: 4 }} /> Tekrar Dene
                        </Button>
                        {errorMessage && (
                            <div className="ErrorMessage">{errorMessage}</div>
                        )}
                    </React.Fragment>
                );
            default:
                return (
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={this.handleAdd}
                        className="VideoRotationButton"
                    >
                        EKLE
                    </Button>
                );
        }
    };

    render() {
        const { video } = this.props;
        const { status } = this.state;

        return (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                <Card className={`VideoRotationCard ${status}`}>
                    <div className="Image">
                        <img alt={video.title} src={video.thumbnail} />
                        <div className="Duration">{video.duration}</div>
                        <div className="SourceSite">{video.sourceSite}</div>
                        <a
                            href={video.sourceUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ExternalLink"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <OpenInNew />
                        </a>
                    </div>
                    <div className="Info">
                        <div className="Title">
                            <h2>{video.title}</h2>
                        </div>
                    </div>
                    <div className="Actions">
                        {this.renderButton()}
                    </div>
                </Card>
            </Grid>
        );
    }
}

export default VideoRotationCard;
